import { SelectInputData } from "@src/components/deprecated/SelectInputField/SelectInputField";
import { ContractorGroupData } from "to-be-removed/LocalData/ContractorGroup/ContractorGroupData";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";
import { InputElementContext } from "../DataObjectField";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataContractorField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<
  ContractorGroupData,
  FirebaseDataType
> {
  override encode = (value: ContractorGroupData) => value.id;

  override convertValueToSelectInput(value: ContractorGroupData): SelectInputData {
    return new SelectInputData(value.id, value.name);
  }
  override getValueForKey(key: string): ContractorGroupData | undefined {
    return LocalData.contractorGroups.getData(key);
  }
  private getAllContractors = (context?: InputElementContext): ContractorGroupData[] => {
    return LocalData.properties.getData(context?.propertyID)?.contractors ?? LocalData.contractorGroups.documents;
  };
  override getOptions(context?: InputElementContext): FirebaseDataSelectFieldOption[] {
    return this.getAllContractors(context)
      .filter((group) => group.loaded && !group.deleted)
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      .map((contractor) => {
        return {
          key: contractor.id,
          label: contractor.name,
        };
      });
  }
  getReadableStringRepresentation(value: ContractorGroupData): string {
    return value.name;
  }

  loadAllDatas(context?: InputElementContext | undefined): Promise<any> {
    const promises: Promise<any>[] = [];
    let contextProperty = LocalData.properties.getData(context?.propertyID);
    const properties = contextProperty ? [contextProperty] : LocalData.currentUser.properties;
    for (const property of properties) {
      for (const contractor of property.contractors) {
        if (property.checkForLandlordRoles(LocalData.currentUser) || LocalData.currentUser.contractorGroups.includes(contractor)) {
          if (!contractor.loaded) {
            promises.push(contractor.load());
          }
        }
      }
    }
    return Promise.all(promises);
  }

  override isValueValid = (value: any): boolean => {
    return value instanceof ContractorGroupData;
  };
}
